var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_facebook",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook/Black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6383553,48 L2.64923152,48 C1.18567266,48 0,46.8135915 0,45.3506028 L0,2.64921096 C0,1.1858497 1.18585891,0 2.64923152,0 L45.3509547,0 C46.8139548,0 48,1.1858497 48,2.64921096 L48,45.3506028 C48,46.8137778 46.8137686,48 45.3509547,48 L33.1193053,48 L33.1193053,29.4117547 L39.3585212,29.4117547 L40.2927552,22.1675856 L33.1193053,22.1675856 L33.1193053,17.5426414 C33.1193053,15.4452873 33.7017116,14.0160097 36.7092896,14.0160097 L40.5453113,14.0143334 L40.5453113,7.53509054 C39.8818859,7.44680835 37.6047835,7.24957027 34.955552,7.24957027 C29.4248342,7.24957027 25.6383553,10.6255263 25.6383553,16.8252089 L25.6383553,22.1675856 L19.3831218,22.1675856 L19.3831218,29.4117547 L25.6383553,29.4117547 L25.6383553,48 L25.6383553,48 Z",
    id: "Facebook"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon_facebook.36fda48600ca8bb386caf761e73f7d91.svg";
export { ForwardRef as ReactComponent };